import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHollowTwinklePlus = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		fill: "none",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M15.24 12.58c-4.572 1.541-6.08 3.257-7.194 7.53C6.93 15.837 5.424 14.12.852 12.58c4.572-1.54 6.08-3.256 7.194-7.529 1.114 4.273 2.622 5.989 7.194 7.53ZM15.528 2.75v5.39M12.833 5.445h5.39"
	}));
});
export default SvgHollowTwinklePlus;
